<div class="row">
  @for (field of field.fieldGroup; track field; let i = $index) {
    <div [class]="((field.parent?.fieldGroup?.length ?? 0) > 1) ? 'col-6' : 'col-12'">
      <formly-field
        [field]="field"
        [attr.id]="props.id ? props.id + '_' + i : null"
      />
    </div>
  }
</div>
